/* Theme-only presentation; EasySearch owns vehicle selection and persistence. */
(function () {
  'use strict';
  if (window.rsgShoppingLoaded) return;
  window.rsgShoppingLoaded = true;

  // Keep the one catalog link useful for shared vehicle URLs and saved selections.
  function syncCatalogLinks() {
    var current = new URL(location.href);
    var match = !current.pathname.includes('/products/') && current.pathname.match(/\/collections\/[^/]+\/([^/]+)\/?$/);
    var app = window.easysearch;
    var tags = (app && app.currentTag) || (match && match[1]) || current.searchParams.get('constraint') || current.searchParams.getAll('filter.p.tag').join('+') || '';
    var vehicleTags = String(tags).split('+').filter(function (tag) { return /^\d{4}-[a-z0-9-]+-esi\d+$/i.test(tag); });
    document.querySelectorAll('[data-rsg-catalog-link]').forEach(function (link) {
      var base = link.dataset.rsgCatalogBase || link.getAttribute('href');
      var target = new URL(base, location.origin);
      if (target.origin !== location.origin || !/\/collections\/all\/?$/.test(target.pathname)) return;
      if (!link.dataset.rsgCatalogBase) link.dataset.rsgCatalogBase = base;
      if (vehicleTags.length) target.pathname = target.pathname.replace(/\/$/, '') + '/' + vehicleTags.join('+');
      var preview = current.searchParams.get('preview_theme_id');
      if (preview) target.searchParams.set('preview_theme_id', preview);
      if (link.href !== target.href) link.href = target.pathname + target.search;
    });
  }
  ['easysearch_loaded', 'easysearch_rendered', 'easysearch_params_saved'].forEach(function (name) { document.addEventListener(name, syncCatalogLinks); });
  window.addEventListener('pageshow', syncCatalogLinks);

  function initVehicle(root) {
    if (root.dataset.rsgBound) return;
    root.dataset.rsgBound = 'true';
    var details = root.querySelector('[data-rsg-vehicle-details]');
    var label = root.querySelector('[data-rsg-vehicle-label]');
    var action = root.querySelector('[data-rsg-vehicle-action]');
    var appliedTag;
    function updateAction() {
      action.textContent = details.open ? 'Hide selector' : (root.dataset.hasVehicle === 'true' ? 'Change vehicle' : 'Select vehicle');
    }
    function sync() {
      var app = window.easysearch;
      if (!app) return;
      var cookie = function (key) { return typeof app.getCookie === 'function' ? (app.getCookie(key) || '') : ''; };
      var tag = app.currentTag || cookie('easysearch-tag-filter');
      var saved = cookie('easysearch-preselect');
      var words = saved.split(app.preSelectDelimiter || 'easysearch-preselect-delimiter').filter(Boolean);
      // A shared vehicle-tag URL can be opened in a fresh browser with no saved selection.
      if (!tag) {
        var match = location.pathname.match(/(?:\/|\+)(\d{4}-[^/]+-esi\d+)(?:\+|$)/);
        if (match) tag = match[1];
        var queryTags = new URL(location.href).searchParams.get('constraint') || new URL(location.href).searchParams.getAll('filter.p.tag').join('+');
        if (!tag && /\d{4}-.+-esi\d+/.test(queryTags)) tag = queryTags;
      }
      var fallback = String(tag || '').split('+').find(function (value) { return /^\d{4}-.+-esi\d+$/.test(value); });
      var text = words.length >= 3 ? words.join(' ') : (fallback ? fallback.replace(/-esi\d+$/, '').replace(/-/g, ' ').replace(/\b[a-z]/g, function (s) { return s.toUpperCase(); }) : 'Selected vehicle');
      root.dataset.hasVehicle = tag ? 'true' : 'false';
      label.textContent = tag ? text : 'No vehicle selected';
      if (tag !== appliedTag) {
        var changeRequested = appliedTag === undefined && new URL(location.href).searchParams.get('rsg_change_vehicle') === '1';
        details.open = root.dataset.placement === 'hero' && (!tag || changeRequested);
        appliedTag = tag;
      }
      updateAction();
    }
    details.addEventListener('toggle', updateAction);
    // Shopify's vendor/type collections use ?constraint=, while this app builds invalid /vendors/TAG routes.
    // Change fitment from the existing home widget instead of altering app internals or shared settings.
    if (/\/collections\/(vendors|types)(?:\/|$)/.test(location.pathname)) {
      details.querySelector('summary').addEventListener('click', function (event) {
        event.preventDefault();
        var home = new URL((window.Shopify && Shopify.routes && Shopify.routes.root) || '/', location.origin);
        home.searchParams.set('rsg_change_vehicle', '1');
        var preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) home.searchParams.set('preview_theme_id', preview);
        home.hash = 'search-filter';
        location.assign(home.href);
      });
    }
    ['easysearch_loaded', 'easysearch_rendered', 'easysearch_params_saved'].forEach(function (name) { document.addEventListener(name, sync); });
    root.addEventListener('click', function (event) {
      if (event.target.closest('.easysearch-btn-clean')) setTimeout(sync, 0);
    });
    var pending = false;
    new MutationObserver(function () {
      if (!pending) {
        pending = true;
        requestAnimationFrame(function () { pending = false; sync(); });
      }
    }).observe(root.querySelector('.easysearch_filter'), { childList: true, subtree: true });
    window.addEventListener('load', sync);
    window.addEventListener('pageshow', sync);
    sync();
  }
  function submitRefinement(event) {
    var form = event.target;
    if (!form.matches('[data-rsg-refine]')) return;
    event.preventDefault();
    event.stopPropagation(); // Own these forms; legacy AJAX and app search rewriting must not run twice.
    var valid = true;
    form.querySelectorAll('[data-rsg-price-range]').forEach(function (range) {
      var min = range.querySelector('input[name$=".gte"]');
      var max = range.querySelector('input[name$=".lte"]');
      max.setCustomValidity('');
      if (min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
        max.setCustomValidity('Maximum price must be at least the minimum price.');
        max.reportValidity();
        valid = false;
      }
    });
    if (!valid) return;
    var url = new URL(location.href);
    var names = new Set(Array.from(form.elements).map(function (field) { return field.name; }).filter(function (name) { return name === 'sort_by' || /^filter\./.test(name); }));
    if (names.has('filter.v.availability')) url.searchParams.delete('options[unavailable_products]');
    names.forEach(function (name) { url.searchParams.delete(name); });
    new FormData(form).forEach(function (value, key) { if (names.has(key) && String(value).trim()) url.searchParams.append(key, value); });
    url.searchParams.delete('page');
    url.hash = /\/collections\//.test(url.pathname) ? 'js-product-ajax' : 'rsg-product-tools';
    location.assign(url.href);
  }
  document.addEventListener('submit', submitRefinement, true);
  document.addEventListener('input', function (event) {
    var range = event.target.closest('[data-rsg-price-range]');
    if (range) range.querySelectorAll('input').forEach(function (input) { input.setCustomValidity(''); });
  });
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rsg-clear],[data-rsg-remove-param],[data-rsg-remove-price]');
    if (!button) return;
    event.preventDefault();
    var url = new URL(location.href);
    if (button.hasAttribute('data-rsg-clear') || button.dataset.rsgRemoveParam === 'filter.v.availability') url.searchParams.delete('options[unavailable_products]');
    if (button.hasAttribute('data-rsg-clear')) {
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (/^filter\./.test(key) && key !== 'filter.p.tag') url.searchParams.delete(key);
      });
    } else if (button.hasAttribute('data-rsg-remove-price')) {
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
    } else {
      var key = button.dataset.rsgRemoveParam;
      if (key === 'filter.p.tag' || !/^filter\./.test(key)) return;
      var remaining = url.searchParams.getAll(key).filter(function (value) { return value !== button.dataset.rsgRemoveValue; });
      url.searchParams.delete(key);
      remaining.forEach(function (value) { url.searchParams.append(key, value); });
    }
    url.searchParams.delete('page');
    url.hash = /\/collections\//.test(url.pathname) ? 'js-product-ajax' : 'rsg-product-tools';
    location.assign(url.href);
  });
  function submitBrowse(event) {
    var form = event.target;
    if (!form.matches('[data-rsg-browse-form]')) return;
    event.preventDefault();
    event.stopPropagation();
    var value = form.querySelector('select').value;
    if (!value) return;
    var kind = form.dataset.rsgBrowseForm;
    var base = form.closest('[data-collections-root]').dataset.collectionsRoot;
    var url = new URL(kind === 'category' ? value : base + '/' + kind, location.origin);
    if (url.origin !== location.origin || !url.pathname.includes('/collections/')) return;
    if (kind !== 'category') url.searchParams.set('q', value);
    var app = window.easysearch;
    var current = new URL(location.href);
    if (kind !== 'category') {
      var pathTags = current.pathname.match(/\/collections\/[^/]+\/(.+)$/);
      var tags = (app && app.currentTag) || (pathTags && pathTags[1]) || current.searchParams.get('constraint') || current.searchParams.getAll('filter.p.tag').join('+');
      if (tags && app && typeof app.legacyTagConverter === 'function') tags = app.legacyTagConverter(tags);
      if (tags) url.searchParams.set('constraint', tags);
    } else if (app && typeof app.collectionUrlTagChecker === 'function') {
      var prepared = app.collectionUrlTagChecker(url.pathname + url.search);
      if (prepared) url = new URL(prepared, location.origin);
    } else {
      var match = location.pathname.match(/\/collections\/[^/]+\/(.+)$/);
      if (match && !url.pathname.match(/\/collections\/[^/]+\//)) url.pathname += '/' + match[1];
      new URL(location.href).searchParams.getAll('filter.p.tag').forEach(function (tag) { url.searchParams.append('filter.p.tag', tag); });
    }
    var preview = current.searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    var sort = current.searchParams.get('sort_by');
    if (['manual','best-selling','title-ascending','title-descending','price-ascending','price-descending','created-ascending','created-descending'].includes(sort)) url.searchParams.set('sort_by', sort);
    url.hash = /\/collections\//.test(url.pathname) ? 'js-product-ajax' : 'rsg-product-tools';
    location.assign(url.href);
  }
  document.addEventListener('submit', submitBrowse, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-rsg-stock-form]')) return;
    event.preventDefault();
    event.stopPropagation();
    var url = new URL(location.href);
    var checked = form.querySelector('[data-rsg-stock-check]').checked;
    var mode = form.dataset.rsgStockForm;
    if (mode === 'all-search' && checked) {
      var match = url.pathname.match(/\/collections\/all\/(.+)$/);
      var tags = (match && match[1]) || url.searchParams.get('constraint') || url.searchParams.getAll('filter.p.tag').join('+') || (window.easysearch && easysearch.currentTag) || '';
      var terms = String(tags).split('+').filter(Boolean).map(function (tag) {
        try { tag = decodeURIComponent(tag); } catch (error) { /* Retain a literal malformed token; never invent fitment. */ }
        return 'tag:"' + tag.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
      });
      url.pathname = form.dataset.searchUrl;
      url.searchParams.set('q', terms.join(' AND ') || '*');
      url.searchParams.set('rsg_stock_catalog', '1');
      if (!['price-ascending','price-descending','relevance'].includes(url.searchParams.get('sort_by'))) url.searchParams.delete('sort_by');
      String(tags).split('+').filter(Boolean).forEach(function (tag) { if (!url.searchParams.getAll('filter.p.tag').includes(tag)) url.searchParams.append('filter.p.tag', tag); });
    }
    url.searchParams.delete('filter.v.availability');
    url.searchParams.delete('options[unavailable_products]');
    if (checked) url.searchParams.set('filter.v.availability', '1');
    if (mode === 'search' || mode === 'all-search' && checked) {
      url.searchParams.set('type', 'product');
      if (checked) url.searchParams.set('options[unavailable_products]', 'hide');
    }
    url.searchParams.delete('page');
    url.hash = /\/collections\//.test(url.pathname) ? 'js-product-ajax' : 'rsg-product-tools';
    location.assign(url.href);
  }, true);
  function initTools(root) {
    var stockCheck = root.querySelector('[data-rsg-stock-check]');
    if (stockCheck) {
      var states = new URL(location.href).searchParams.getAll('filter.v.availability').join(',').split(',');
      stockCheck.checked = states.includes('1') && !states.includes('0') || new URL(location.href).searchParams.get('options[unavailable_products]') === 'hide';
    }
    if (new URL(location.href).searchParams.get('rsg_stock_catalog') === '1') {
      var heading = document.querySelector('.section-header__title');
      var summary = document.querySelector('.section-header__subtext');
      var count = root.querySelector('.rsg-result-count');
      if (heading) heading.textContent = stockCheck && stockCheck.checked ? 'In-stock parts' : 'Catalog search';
      if (summary && count) summary.textContent = count.textContent;
    }
    var clear = root.querySelector('[data-rsg-clear]');
    if (clear) clear.hidden = !Array.from(new URL(location.href).searchParams.keys()).some(function (key) { return /^filter\./.test(key) && key !== 'filter.p.tag' || key === 'options[unavailable_products]'; });
    if (root.dataset.rsgBound) return;
    root.dataset.rsgBound = 'true';
    var dataNode = root.querySelector('[data-rsg-browse-data]');
    if (!dataNode) return;
    var data;
    try { data = JSON.parse(dataNode.textContent); } catch (error) { return; }
    ['vendors','types'].forEach(function (kind) {
      var select = root.querySelector('[data-rsg-browse-form="' + kind + '"] select');
      (data[kind] || []).filter(function (value) { return typeof value === 'string' && value.trim(); }).forEach(function (value) { select.add(new Option(value, value)); });
    });
    var categories = document.querySelector('[data-rsg-categories]');
    var categorySelect = root.querySelector('[data-rsg-browse-form="category"] select');
    function refreshCategories() {
      if (!categories) return;
      if (!['ready','partial'].includes(categories.dataset.rsgState)) return;
      var selected = categorySelect.value;
      categorySelect.replaceChildren(new Option('Choose a category', ''));
      var all = categories.querySelector('.rsg-all-parts');
      if (all) categorySelect.add(new Option('All parts', all.getAttribute('href')));
      categories.querySelectorAll('[data-rsg-group]:not([hidden])').forEach(function (group) {
        var optgroup = document.createElement('optgroup');
        optgroup.label = group.querySelector('summary').textContent.trim();
        group.querySelectorAll('[data-rsg-category]:not([hidden]) a').forEach(function (link) { optgroup.append(new Option(link.querySelector('span').textContent, link.getAttribute('href'))); });
        if (optgroup.children.length) categorySelect.append(optgroup);
      });
      if (Array.from(categorySelect.options).some(function (option) { return option.value === selected; })) categorySelect.value = selected;
      categorySelect.disabled = categorySelect.options.length < 2;
    }
    if (categories) new MutationObserver(refreshCategories).observe(categories, { attributes: true, attributeFilter: ['data-rsg-state'] });
    refreshCategories();
  }
  function initSidebar(root) {
    if (root.dataset.rsgSidebarBound) return;
    var toggle = document.querySelector('[data-rsg-sidebar-toggle]');
    var close = root.querySelector('[data-rsg-sidebar-close]');
    if (!toggle || !close) return;
    root.dataset.rsgSidebarBound = 'true';
    var mobile = matchMedia('(max-width:991px)');
    var opened = false;
    function setOpen(value) {
      var wasOpen = opened;
      opened = value && mobile.matches;
      root.classList.toggle('active', opened);
      toggle.classList.toggle('active', opened);
      toggle.setAttribute('aria-expanded', String(opened));
      root.inert = mobile.matches && !opened;
      root.setAttribute('role', opened ? 'dialog' : 'complementary');
      if (opened) root.setAttribute('aria-modal', 'true'); else root.removeAttribute('aria-modal');
      if (root.inert) root.setAttribute('aria-hidden', 'true'); else root.removeAttribute('aria-hidden');
      if (opened) close.focus(); else if (wasOpen && mobile.matches) toggle.focus();
    }
    [toggle, close].forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation(); // Do not also run the legacy theme drawer handler.
        setOpen(button === toggle && !opened);
      }, true);
    });
    root.addEventListener('keydown', function (event) {
      if (!opened) return;
      if (event.key === 'Escape') { event.preventDefault(); setOpen(false); }
      if (event.key !== 'Tab') return;
      var controls = Array.from(root.querySelectorAll('button:not(:disabled),select:not(:disabled),input:not(:disabled),a[href],summary')).filter(function (item) { return item.getClientRects().length && getComputedStyle(item).visibility !== 'hidden'; });
      var first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    mobile.addEventListener('change', function () { setOpen(false); });
    setOpen(false);
  }
  function init() {
    syncCatalogLinks();
    document.querySelectorAll('.rsg-collection-sidebar').forEach(initSidebar);
    document.querySelectorAll('[data-rsg-vehicle]').forEach(initVehicle);
    document.querySelectorAll('.rsg-product-tools').forEach(initTools);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
